import { render, staticRenderFns } from "./KplayLive.vue?vue&type=template&id=222da8ef&scoped=true"
import script from "./KplayLive.vue?vue&type=script&lang=js"
export * from "./KplayLive.vue?vue&type=script&lang=js"
import style0 from "./KplayLive.vue?vue&type=style&index=0&id=222da8ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222da8ef",
  null
  
)

export default component.exports